/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: BUSL-1.1
 */

import Route from '@ember/routing/route';
import type ReportingInventoryController from '../../controllers/reporting/secrets-inventory';

export default class ReportingInventoryRoute extends Route {
  queryParams = {
    cluster: {
      replace: true,
      refreshModel: false,
    },
    filters: {
      replace: true,
      refreshModel: false,
    },
    pagination: { replace: true, refreshModel: false },
    sortingOrderBy: {
      replace: true,
      refreshModel: false,
    },
  };

  resetController(
    controller: ReportingInventoryController,
    isExiting: boolean,
  ): void {
    if (isExiting) {
      // reset params
      controller.set('cluster', '');
      controller.set('filters', []);
      controller.set('pagination', {
        page_size: null,
        next_page_token: null,
        previous_page_token: null,
      });
    }
  }
}
